<template>
    <div>
        <Navigation></Navigation>
        <div v-if="flash" class="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Successfully Unsubscribed!</strong>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <header id="unsubscribe" class="text-center mt-5">
            <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xl-9 mx-auto">
                    <h1 class="mb-5">Unsubscribe</h1>
                    </div>
                    <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
                    <form>
                        <div class="form-row">
                        <div class="col-12 col-md-9 mb-2 mb-md-0">
                            <input v-model="userEmail" type="email" class="form-control form-control-lg" placeholder="Enter your email...">
                        </div>
                        <div class="col-12 col-md-3">
                            <button @click.prevent="unsubscribe()" type="submit" class="btn btn-block btn-lg btn-danger">Opt Me Out!</button>
                        </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import Navigation from './sub/Navigation';
import { API } from 'aws-amplify';
import { updateSubscriber } from '../graphql/mutations';
import * as queries from '../graphql/queries';

export default {
    name: 'Unsubscribe',
    components: {
        Navigation
    },
    data: function() {
        return {
            userEmail: '',
            flash: false
        }
    },
    methods: {
        unsubscribe() {
            const userEmail = this.userEmail;
            if (!userEmail) return;
            API.graphql({ query: queries.listSubscribers }).then(d => {
                d.data.listSubscribers.items.map(s => {
                    if(s.email === userEmail) {
                        API.graphql({
                            query: updateSubscriber,
                            variables: {input: {id: s.id, subscribed: false}},
                        }).then(e => {
                            this.userEmail = '';
                            this.flash = true;
                        })
                    }
                });
            });
            
        }
    }
}
</script>